// Contacts

import bsCustomFileInput from 'bs-custom-file-input';

// Init input file component

$(function () {
  bsCustomFileInput.init();
});
